import React from "react";
import {
  Stack,
  Typography,
  Box,
} from "@mui/material";

import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import MenuCard from "./MenuCard";

const ActivitySection = ({
  stats,
  navigate,
}) => {
  const activityItems = [
    {
      title: "My Orders",
      subtitle: "Medicine, Diagnostic & Nursing orders",
      icon: <ShoppingBagOutlinedIcon />,
      badge: stats?.orders || 0,
      color: "#1976D2",
      onClick: () => navigate("/all-orders"),
    },
     {
      title: "Package Bookings",
      subtitle: "Diagnostic orders",
      icon: <ShoppingBagOutlinedIcon />,
      badge: 0,
      color: "#1976D2",
      onClick: () => navigate("/my-packagebookings"),
    },

      {
        title: "Doctor Appointments",
        subtitle: "Book and manage your doctor consultations",
        icon: <HealthAndSafetyOutlinedIcon />,
        badge: stats?.doctorAppointments || 0,
        color: "#00897B",
        onClick: () => navigate("/mydoctor-appointments"),
      },

    {
      title: "Diagnostic Reports",
      subtitle: "View and download reports",
      icon: <DescriptionOutlinedIcon />,
      badge: stats?.reports || 0,
      color: "#7B1FA2",
      onClick: () => navigate("/diagnostic-reports"),
    },
    
    {
      title: "Prescriptions",
      subtitle: "Uploaded prescriptions",
      icon: <MedicalServicesOutlinedIcon />,
      badge: stats?.prescriptions || 0,
      color: "#2E7D32",
      onClick: () => navigate("/prescriptions"),
    },
    {
      title: "Reward Points",
      subtitle: "Rewards & redeem points",
      icon: <WorkspacePremiumOutlinedIcon />,
      badge: stats?.rewardPoints || 0,
      color: "#FB8C00",
      onClick: () => navigate("/rewards"),
    },
    {
      title: "Complaints",
      subtitle: "Track your support requests",
      icon: <SupportAgentOutlinedIcon />,
      badge: stats?.complaints || 0,
      color: "#D32F2F",
      onClick: () => navigate("/complaints"),
    },
    {
      title: "Feedback",
      subtitle: "Ratings & reviews",
      icon: <RateReviewOutlinedIcon />,
      badge: stats?.feedback || 0,
      color: "#009688",
      onClick: () => navigate("/feedback"),
    },
  ];

  return (
    <Box>
      <Typography
        variant="h6"
        fontWeight={700}
        mb={2}
      >
        My Activity
      </Typography>

      <Stack spacing={2}>
        {activityItems.map((item) => (
          <MenuCard
            key={item.title}
            title={item.title}
            subtitle={item.subtitle}
            icon={item.icon}
            badge={item.badge}
            color={item.color}
            onClick={item.onClick}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ActivitySection;